<div
    class="tw-w-[350px] md:tw-w-[502px] md:tw-px-[37px] md:tw-py-[26px] tw-p-[16px] tw-h-[400px] tw-bg-white tw-rounded-[24px] tw-flex tw-flex-col tw-relative tw-z-[2]"
>
    <header class="tw-flex tw-justify-end tw-items-center">
        <button mat-icon-button (click)="onDialogClose(true)">
            <mat-icon class="close-icon" aria-label="Close dialog"
                >close</mat-icon
            >
        </button>
    </header>
    <div class="tw-mt-2 tw-justify-center tw-flex tw-flex-col tw-items-center">
        <div
            class="tw-mb-[23px] tw-h-[52px] tw-w-[52px] tw-rounded-full tw-border-2 tw-border-[#FFA53C] tw-flex tw-justify-center tw-items-center"
        >
            <mat-icon class="tw-text-[#FFA53C] mail-icon" aria-label="Mail icon"
                >mail_outline</mat-icon
            >
        </div>
        <div
            class="tw-justify-center tw-flex tw-flex-col tw-items-center tw-text-center tw-gap-[15px]"
        >
            <div
                class="tw-text-[14px] md:tw-text-[18px] tw-font-bold tw-w-full"
            >
                {{ "COMMON.ACCOUNT_UNVERIFIED" | translate }}
            </div>
            <!-- description tablet & desktop view -->
            <div
                class="tw-hidden md:tw-block tw-text-[14px] tw-leading-[20px] tw-w-full tw-text-[#7B7575]"
            >
                {{ "COMMON.ACCOUNT_UNVERIFIED_DESC_1" | translate }}
                <span class="tw-font-bold">{{
                    userDetails?.email || userDetails?.username
                }}</span
                >.
                {{ "COMMON.ACCOUNT_UNVERIFIED_DESC_2" | translate }}
            </div>
            <!-- description mobile view -->
            <div
                class="tw-block md:tw-hidden tw-text-[12px] tw-leading-[20px] tw-w-full tw-text-[#7B7575]"
            >
                {{ "COMMON.ACCOUNT_UNVERIFIED_DESC_1" | translate }}
                <span class="tw-font-bold">{{
                    userDetails?.email || userDetails?.username
                }}</span
                >.
                <span class="tw-block tw-leading-[20px]">{{
                    "COMMON.ACCOUNT_UNVERIFIED_DESC_2" | translate
                }}</span>
            </div>
            <button
                type="button"
                class="tw-py-4 tw-px-8 tw-text-[14px] tw-font-bold tw-text-white tw-bg-[#FFA53C] tw-rounded-[32px]"
                (click)="sendVerificationCode()"
            >
                {{ "COMMON.SEND_VERIFICATION_CODE" | translate }}
            </button>
            <button
                type="button"
                class="tw-text-[14px] tw-font-semibold tw-underline tw-text-[#7B7575]"
                (click)="backToLogin()"
            >
                {{ "COMMON.BACK_TO_LOGIN" | translate }}
            </button>
        </div>
    </div>
</div>
